<template>
  <v-form ref="form" v-model="isFormValid" class="px-md-12 mx-md-12">
    <v-row>
      <v-col cols="12">
        <h1 >{{ title }}</h1>
      </v-col>
      <v-col cols="12" class="mb-5">
        <v-text-field
          class="pr-4"
          v-model="dynamicContent.name"
          type="text"
          label="Name*"
          hint="Must only contain lowercase alphabets, numbers or underscores."
          persistent-hint
          outlined
          :rules="validationRules.contentName"
        />
      </v-col>
      
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2 >Original Content Preview</h2>
      </v-col>
      <v-col cols="12" class="pt-0">
        <div class="subtitle-1">
          This content will be displayed to the contacts who do not fall into
          any of the below segment groups (under rules).
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" v-if="contentId ? dynamicContent.contentFeedId !== undefined : true">
        <auto-complete
          :selection.sync='dynamicContent.contentFeedId'
          :apiName="getContentApiName"
          :responseName="'content_feeds'"
          label="Content Feed"
          :dataList="contentFeedDataList"
          :sortBy="'desc'"
          :sortValue="'updated_at'"
          :noFolder="true"
        />
      </v-col>
      
    </v-row>
    <v-row>
      <v-col cols="12">
        <ck-editor
          editorId="editor"
          :value.sync="dynamicContent.editor"
          :rules="validationRules.editor"
          :tagPlugins="tagPlugins"
          toolbar= "DynamicContentEditor"
        ></ck-editor>
        <br/>
        <content-feed-preview
          :html-part="dynamicContent.editor"
          :content-feed-id="dynamicContent.contentFeedId"
        ></content-feed-preview>
      </v-col>
        <v-col cols="12" class="px-0">
        <!-- Rule Listing  -->
        <dynamic-content-rule-list
          :rules.sync="rules"
          :validation-rules="validationRules.rules"
          ref="ruleList"
        />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="d-flex justify-end" >
        <v-btn
          outlined
          v-track="'new-dynamic-content-cancel'"
          class="mr-8"
          @click="navigateToListing" 
        >
          cancel
        </v-btn>
        <v-btn
          :dark="areFormsValid"
          class="ck-editor-save"
          :class="{'v-btn--disabled' : !areFormsValid}"
          v-track="'new-dynamic-content-save'"
          @click="submitHandler"
        >
          save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { $contentFeeds } from "@/services";
import CkEditor from './CkEditor.vue';
import DynamicContentRuleList from "./DynamicContentRuleList.vue";
import ContentFeedPreview from "./ContentFeedPreview.vue";
import AutoComplete from '@/components/ui/AutoComplete.vue'
export default {
  name: 'DynamicContentForm',
  components: {
    AutoComplete,
    DynamicContentRuleList,
    ContentFeedPreview,
    CkEditor,
  },
  emits:['save'],
  data() {
    return {
      isFormValid: false,
      contentFeed: [],
      allSegments: [], 
      validationRules: {
        contentName: [
          v => !!v || "Name is required",
          v =>
            /^[a-z0-9_]+$/.test(v) ||
            "Must only contain lowercase letters, numbers or underscores."
        ],
        editor:[
          v => !!v || "Content is required",
        ],
        rules:{
          ruleSegmentId:[
            v => !!v || "Segment is required"
          ],
          html:[
            v => !!v || "Content is required"
          ],
          ruleContentFeedId:[]
        }
      },
      tagPlugins:'campaigntags,dynamictags,contacttags,coupontags,tabletags,othertags,productfeedtemplatestags'
    };
  },
  props:{
    title:{
      type:String,
      required: true
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    dynamicContent: {
      type: Object,
      required: true,
      default: () =>({
        name: "",
        contentFeedId: null,
        editor: ''
      })
    },
    rules: {
      type: Array,
      required: true,
      default:() =>([
        {
          ruleSegmentId: null,
          ruleContentFeedId: null,
          html: ""
        }
      ])
    },
  },
  computed: {
    areFormsValid(){
      return this.isFormValid && this.$refs.ruleList.isFormValid;
    },
    getContentApiName(){
      return $contentFeeds.fetch;
    },
    contentId(){
      return this.$route.params && this.$route.params.content_id
    },
    contentFeedDataList(){
      return this.dynamicContent.contentFeedId 
        ? [{
          id: this.dynamicContent.contentFeedId, 
          name: this.dynamicContent.contentFeedName
        }]
        : []
    }
  },
  methods: {
    navigateToListing() {
      if (this.isDialog) {
        this.$emit('cancel');
      } else {
        this.$router.push({name: 'Dynamic_contents'})  
      }
    },
    submitHandler() {
      const ruleListFormCheck = this.$refs.ruleList.$refs.form.validate();
      if (!this.$refs.form.validate() || !ruleListFormCheck) {
        return
      }
      const formData = this.createFormData();

      this.$emit('save', formData);
    },
    createFormData(){
      const formData = new FormData();
      formData.append("dynamic_content[name]", this.dynamicContent.name);
      
      if(this.contentId && !this.dynamicContent.contentFeedId){
        formData.append(
          `dynamic_content[content_feed_id]`,
          ''
        );
      } else {
        this.dynamicContent.contentFeedId && formData.append(
          "dynamic_content[content_feed_id]",
          this.dynamicContent.contentFeedId
        );
      }
      
      formData.append("dynamic_content[html]", this.dynamicContent.editor);
      
      return formData;
    }
  }
};
</script>
